import React from "react";

export default function AWS_SNS() {
  return (
    <div>
      <h1>What is AWS SNS</h1>
      <p>
        Route: <code>/aws/sns</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
